import { render, staticRenderFns } from "./searchGbrk.vue?vue&type=template&id=25f8a0f8"
import script from "./searchGbrk.vue?vue&type=script&lang=js"
export * from "./searchGbrk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports